import { render, staticRenderFns } from "./authorInfo.vue?vue&type=template&id=5df26c28&scoped=true"
import script from "./authorInfo.vue?vue&type=script&lang=ts"
export * from "./authorInfo.vue?vue&type=script&lang=ts"
import style0 from "./authorInfo.vue?vue&type=style&index=0&id=5df26c28&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df26c28",
  null
  
)

export default component.exports